import { Route, Routes } from 'react-router-dom';

import { List } from './List';

export default function DeclareRegisterInvoiceND123() {

  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  );
}
